import React from "react";
import { withTranslation } from "react-i18next";
import { ProgressSpinner } from "primereact/progressspinner";

const WaitDialog = ({ loading }) => {
  if (!loading) return null; 

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.1)", 
        backdropFilter: "blur(1px)", 
        zIndex: 9999, 
      }}
    >
      <ProgressSpinner style={{ width: "60px", height: "60px" }} />
    </div>
  );
};

export default withTranslation()(WaitDialog);